(function () {
  var CLASE = 'vz-talla-pendiente';
  var OBJETIVOS = 'button[name="add"], .product-bar__submit, .shopify-payment-button, shopify-accelerated-checkout, .product-form__submit';
  var pendiente = false;

  function radiosDeTalla() {
    return Array.prototype.filter.call(
      document.querySelectorAll('.product__variant-picker input[type="radio"]'),
      function (radio) {
        return /talla/i.test(radio.name || '');
      }
    );
  }

  function iniciar() {
    var hayTallas = radiosDeTalla().length > 1;
    var yaElegida = new URL(window.location.href).searchParams.has('variant');
    pendiente = hayTallas && !yaElegida;
    document.documentElement.classList.toggle(CLASE, pendiente);
  }

  function resolver() {
    if (!pendiente) return;
    pendiente = false;
    document.documentElement.classList.remove(CLASE);
    document.querySelectorAll('.vz-talla-aviso').forEach(function (nodo) {
      nodo.remove();
    });
  }

  function avisar() {
    var radios = radiosDeTalla();
    var conjunto = radios[0] && radios[0].closest('fieldset');
    if (!conjunto) return;

    conjunto.scrollIntoView({ behavior: 'smooth', block: 'center' });
    conjunto.classList.remove('vz-talla-sacudir');
    void conjunto.offsetWidth;
    conjunto.classList.add('vz-talla-sacudir');

    if (!conjunto.querySelector('.vz-talla-aviso')) {
      var aviso = document.createElement('p');
      aviso.className = 'vz-talla-aviso';
      aviso.setAttribute('role', 'alert');
      aviso.textContent = 'Elige tu talla para continuar.';
      conjunto.appendChild(aviso);
    }
  }

  document.addEventListener(
    'click',
    function (evento) {
      if (!pendiente) return;
      var objetivo = evento.target instanceof Element ? evento.target.closest(OBJETIVOS) : null;
      if (!objetivo) return;
      if (objetivo.closest('product-card, .product-card, quick-cart-drawer')) return;
      evento.preventDefault();
      evento.stopImmediatePropagation();
      avisar();
    },
    true
  );

  document.addEventListener(
    'submit',
    function (evento) {
      if (!pendiente) return;
      var form = evento.target;
      if (!(form instanceof Element) || !form.matches('form[action*="/cart/add"]')) return;
      if (!form.closest('.product__content, product-info')) return;
      evento.preventDefault();
      evento.stopImmediatePropagation();
      avisar();
    },
    true
  );

  document.addEventListener('change', function (evento) {
    var radio = evento.target;
    if (radio instanceof HTMLInputElement && radio.type === 'radio' && /talla/i.test(radio.name || '')) resolver();
  });

  document.addEventListener('click', function (evento) {
    var etiqueta = evento.target instanceof Element ? evento.target.closest('.product-option__label--square') : null;
    if (!etiqueta) return;
    var radio = etiqueta.previousElementSibling;
    if (radio && radio.tagName === 'INPUT' && /talla/i.test(radio.name || '') && !radio.disabled) {
      setTimeout(resolver, 0);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
